var $320caa0a9583ce6b$exports = {};
$320caa0a9583ce6b$exports = {
    "actions": `Radnje`,
    "actionsAvailable": `Dostupne su radnje.`,
    "clearSelection": `Poni\u{161}ti izbor`,
    "selected": (args)=>`Izabrano: ${args.count}`,
    "selectedAll": `Sve je izabrano`
};


export {$320caa0a9583ce6b$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
